// extracted by mini-css-extract-plugin
export var imageWrapper = "ArticleHeader-module--imageWrapper--AdsRG";
export var tags = "ArticleHeader-module--tags--8RN60";
export var text = "ArticleHeader-module--text--EPkhc";
export var title = "ArticleHeader-module--title--LkUks";
export var wrapper = "ArticleHeader-module--wrapper--fnvcT";